export const BASE_URL = process.env.REACT_APP_API_DOMAIN;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const homeBaseUrl =
  process.env.REACT_APP_SPECIAL_URL ?? "https://missingskincare.com/";

export const CATEGORY = "category";
export const PRODUCT = "product";
export const RECOMMENDED = "recommended";
export const SKIN_PROFILE = "profile/skin-profile";
export const EARN_CASHBACK = "profile/cash-back";
export const LINKED_ACCOUNT = "profile/link-paypal";
export const SURVEY_CREATE = "survey/create";
export const SURVEY = "survey";
export const REVISE = "survey/revise";
export const EMAIL_REMINDER = "profile/email-reminder";

export const UPDATE_PROFILE = "profile/update";
export const PROFILE = "profile";
export const LOGIN = "login";
export const REGISTER = "register";
export const FORGOT_PASSWORD = "password/email";
export const EMAIL_VALIDATION = "validate-email";

export const HOLISTIC_SKINCARE = "holistic-product";
export const SKINCARE_STEPS = "product/skincare-steps";
export const MISSING_SKINCARE = "product/missing-skincare";
export const BROKEN_LINK = "product/notify-broken-link";

// export const PAYMENT_INTENT = "payment/payment-intent";
export const PAYMENT_INTENT = "payment/initialize-payment";

// export const PAYMENT_PROCESS = "payment/pay";
export const PAYMENT_PROCESS = "payment/process-subscription";

export const REFERRAL_HISTORY = "referral/history";

export const REVIEW = "feedback";

export const RECOMMENDATION = "profile/recommendation";

export const PAYMENT_CHECKOUT = "https://buy.stripe.com/00gbJFgMs2xU1jy3cd";

export const FEEDBACK = "customer-feedback";

export const SKINCARE_TRACKER = "skincare-tracker";

export const SKIN_SOLUTION = "skin-solution";

export const PERSONAL_JOURNAL = "skin-progress-journal";

export const INGREDIENT_CHECKER = "ingredient-checker";

export const REVISE_ROUTINE = "survey/routine-revision";

export const SUBSCRIPTION_PLANS = "payment/subscription-plans";

export const CANCEL_SUBSCRIPTION = "payment/cancel-subscription";

export const TOGGLE_SUBSCRIPTION = "payment/toggle-subscription";

export const BILLING_HISTORY = "payment/billing-history";
